import { useFlags } from "launchdarkly-react-client-sdk";

import { FeatureFlag } from "featureFlags/constants";
import { FlagsInterface } from "featureFlags/hooks/useAllFlags";

export const useDemoTool = () => {
  const flags = useFlags<Partial<FlagsInterface>>();
  return !!flags[FeatureFlag.FireboltAppEnableDemoTool];
};
